/**
 * "Totalt betalt" — what the buyer paid, on the seller's breakdown
 * (P25009-494 BR-8).
 *
 * The seller's rows above it are the buyer's rows, incl. VAT, so they add up to
 * this line; the commission below it comes off it, and what is left is the
 * payout. It is the order's payinTotal: the amount the order charged, never a
 * figure recomputed from a listing or a freight rule.
 */
import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemTotalPaidMaybe = props => {
  const { transaction, intl } = props;
  const payinTotal = transaction?.attributes?.payinTotal;
  if (!payinTotal) {
    return null;
  }

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>
          <FormattedMessage id="OrderBreakdown.totalPaid" />
        </div>
        <div className={css.totalPrice}>{formatMoney(intl, payinTotal)}</div>
      </div>
    </>
  );
};

LineItemTotalPaidMaybe.propTypes = {
  transaction: propTypes.transaction.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPaidMaybe;
